import styled from 'styled-components'
import { width, WidthProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { motion } from 'framer-motion'

const TRANSITION = 'all 0.4s ease'

export const Container = styled(motion.div)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ImageHolder = styled.div<WidthProps>`
  overflow: hidden;
  flex-shrink: 0;
  height: 110px;
  width: 110px;
  border-radius: 55px;
  border: 3px solid ${themeGet('colors.primary.main')};

  > img {
    width: 100%;
    height: 100%;
    transform: scale(103%, 103%);
  }

  ${width}
`

export const TextHolder = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: ${TRANSITION};
  gap: ${themeGet('space.2')}px;
  height: 108px;
  width: 120px;
`
